import { render, staticRenderFns } from "./ThirdScreen.vue?vue&type=template&id=680568c5&scoped=true&"
import script from "./ThirdScreen.vue?vue&type=script&lang=js&"
export * from "./ThirdScreen.vue?vue&type=script&lang=js&"
import style0 from "./ThirdScreen.vue?vue&type=style&index=0&id=680568c5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680568c5",
  null
  
)

export default component.exports